import { ArtistType, LinkableEntityType } from '@api';
import { FormActions } from '@common';
import { MultiSelectField } from '@hypeit-gmbh/hypeit-ui';
import { Stack } from '@mantine/core';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  ArtistContractingPartyFormSchemaType,
  useArtistContractingPartyForm,
  useUpdateArtistContractingParty,
} from './hooks';

type EditArtistContractingPartyFormPropsType = {
  artist: ArtistType;
  allPersons: LinkableEntityType[];
  allCompanies: LinkableEntityType[];
  onClose: () => void;
};

export const EditArtistContractingPartyForm: React.FC<
  EditArtistContractingPartyFormPropsType
> = ({ artist, allPersons, allCompanies, onClose }) => {
  const { t } = useTranslation('artistDetailsFinance');
  const form = useArtistContractingPartyForm(artist);
  const { submitUpdateArtistContractingParty } =
    useUpdateArtistContractingParty(artist.id);

  const handleSubmit = async (
    data: ArtistContractingPartyFormSchemaType
  ): Promise<void> => {
    await submitUpdateArtistContractingParty(data);
    onClose();
  };

  const personsData = allPersons.map((person) => ({
    value: person.id,
    label: person.name,
  }));
  const companiesData = allCompanies.map((company) => ({
    value: company.id,
    label: company.name,
  }));

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)}>
        <Stack>
          <MultiSelectField
            fieldName="contractingPartyPersons"
            data={personsData}
            label={t('FORM.PERSONS_LABEL')}
            searchable
          />
          <MultiSelectField
            fieldName="contractingPartyCompanies"
            data={companiesData}
            label={t('FORM.COMPANIES_LABEL')}
            searchable
          />
          <FormActions
            onCancel={onClose}
            saveButtonText={t('SAVE_BUTTON', { ns: 'common' })}
            cancelButtonText={t('CANCEL_BUTTON', { ns: 'common' })}
          />
        </Stack>
      </form>
    </FormProvider>
  );
};
